export default "__VITE_ASSET__P6lo2_da__"